export const response_error_messages = {
  email_not_found: "user-not-found",
  reset_email_not_found: "EMAIL_NOT_FOUND",
  invalid_password: "wrong-password",
  invalid_email: "The email address is invalid",
  email_exists: "email-already-in-use",
  recent_login_needed: "requires-recent-login",
  auth_incorrect_email: "user-mismatch",
  cookbook_exists: "already exist",
};

export const error_messages = {
  email_required: "يجب اضافة البريد الالكتروني",
  password_required: "يجب ملء خانة كلمة المرور",
  min_password: "كلمة المرور من 6 احرف على الاقل",
  confirm_password_match: "كلمات المرور غير متطابقة",
  email_not_found: "البريد الالكتروني غير مسجل",
  password_incorrect: "كلمة المرور غير صحيحة",
  invalid_email: "البريد الالكتروني غير صحيح",
  invalid_password: "كلمة المرور غير صالحة",
  email_exists: "هذا البريد الالكتروني مسجل من قبل",
  re_login: "تسجل من جديد للاستمرار بالتصفح",
  incorrect_email_or_password:
    "كلمة المرور غير صحيحة او البريد الالكتروني غير مسجل ",
  auth_incorrect_email_or_password:
    "البريد الالكتروني او كلمة المرور غير صحيحة",
  cookbook_exists: "كتاب طبخ موجود",
};

export const alert_messages = {
  favorited: "تم إضافة وصفة إلى المفضلة لديك",
  unfavorited: "تم إزالة وصفة من المفضلة لديك",
  not_ready: "سيتم تفعيل هذه الميزة قريباً",
  added_to_cookbook: "تم إضافة الوصفة إلى كتاب الطبخ",
  removed_from_cookbook: "تم إزالة الوصفة من كتاب الطبخ",
};

export const buttons_text = {
  favorite: "أضيفي إلى المفضلة",
  unfavorite: "إزالة من المفضلة",
  favorited: "وصفة مفضلة",
};
